import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {QuestionAnswer} from '../models/question-answer';
import {HttpClient} from '@ispm-client/modules/core/services/http-client';
import {ProcessExecutionStatus} from '@ispm-shared/modules/bpmn';
import {ProcessInputDataUtils} from './process-input-data-utils';
import {EXECUTION_URL} from '@ispm/shared/bpmn/services/config';

@Injectable()
export class BpmnEngineService {

  constructor(private http: HttpClient) {
  }

  startExecution(processId: string, input, kb: string): Observable<ProcessExecutionStatus> {
    return this.http.post(EXECUTION_URL, {processId: processId, data: input, kb: kb});
  }

  getExecutionStatus(processInstanceId: string, kb: string): Observable<ProcessExecutionStatus> {
    const executionStatusUrl = `${EXECUTION_URL}/${processInstanceId}/status`;
    return this.http.get<ProcessExecutionStatus>(executionStatusUrl, {kb: kb}, false, {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    });
  }

  updateTaskData(taskId: string, processInstanceId: string, questionsAndAnswers: QuestionAnswer[], kb: string) {
    const updateTaskDataUrl = `${EXECUTION_URL}/${taskId}`;
    const requestBody = {
      processInstanceId: processInstanceId,
      data: ProcessInputDataUtils.convertMultipleQuestionAnswersToJson(questionsAndAnswers),
      kb: kb
    };
    return this.http.put(updateTaskDataUrl, requestBody, null, {Accept: 'application/xml'});
  }

}
